import {
    baseEnumComparator,
    sortWithNilLast,
} from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';
import * as SetAggLabels from './EnumMaps';

const baseEnumCols: Partial<Column<ColumnType.ENUM>> = {
    ...getBaseColumn(ColumnType.ENUM),
    sortCompareFunction: baseEnumComparator,
    allowSetFilter: true,
};

export const dcat = {
    ...baseEnumCols,
    name: 'Ord Date Cat',
    dataField: 'dcat',
    width: 92,
    enumMap: SetAggLabels.dcat,
    tag: 'Order Data/Ord Date Cat',
    desc: 'Order date category',
    colType: ColumnType.DAY_ENUM,
};

export const liq = {
    ...baseEnumCols,
    name: 'Liq Cat',
    dataField: 'liq',
    width: 90,
    enumMap: SetAggLabels.liq,
    tag: 'Order Data/Liq Cat',
    desc: 'Liquidity category',
};

export const mcap = {
    ...baseEnumCols,
    name: 'Mkt Cat',
    dataField: 'mcap',
    width: 90,
    enumMap: SetAggLabels.mcap,
    tag: 'Market Data/Mkt Cat',
    desc: 'Symbol market capitalization category',
};

export const svol = {
    ...baseEnumCols,
    name: 'Vol Cat',
    dataField: 'svol',
    width: 90,
    enumMap: SetAggLabels.svol,
    tag: 'Market Data/Vol Cat',
    desc: 'Volume category',
};

export const side = {
    ...baseEnumCols,
    name: 'Side',
    dataField: 'side',
    // width: 16,   See SIDE_COLUMN_WIDTH
    tag: 'Order Data/Side',
    desc: 'Side: buy(B)  sell(S) or short(SS)',
    sortCompareFunction: sortWithNilLast<'B' | 'S' | 'SS'>((a, b) =>
        a.localeCompare(b)
    ),
    allowStrMatch: false,
    enumMap: SetAggLabels.side,
};
